import { Component, Input } from '@angular/core';
import { CurrencyConstants } from '../../../models/constants/currency.constants';
import { Currency } from '@shopping-angular-components/dual-currency-modal';

@Component({
  selector: 'dual-currency-modal-wrapper',
  templateUrl: './dual-currency-modal-wrapper.component.html'
})
export class DualCurrencyModalWrapperComponent {

    @Input() currentCurrency: Currency = CurrencyConstants.CURRENCY_CODE_USD;
    @Input() alternativeCurrency: Currency = CurrencyConstants.CURRENCY_CODE_ARS;
    @Input() size: string = '-md';
    @Input() texts = {};

    @Input() onSwitchCurrency?: (currency: Currency) => void;
    @Input() onKeepCurrency?: (currency: Currency) => void;

    onCurrencySelected(event: { modalCurrencySelected: Currency }) {
      const selected = event.modalCurrencySelected;

      if (selected === this.alternativeCurrency) {
        this.onSwitchCurrency?.(selected);
      } else {
        this.onKeepCurrency?.(selected);
      }
    }

}
